// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.spotlight.RentalManagerUserPropertySpotlightWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertySpotlightWebApiHandler_apply,
  RentalManagerUserPropertySpotlightWebApiHandler_list,
  RentalManagerUserPropertySpotlightWebApiHandler_list_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_overview,
  RentalManagerUserPropertySpotlightWebApiHandler_overview_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_reassign,
  RentalManagerUserPropertySpotlightWebApiHandler_remove,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GetSpotlightedListingsResponseDto,
  GetUserPropertySpotlightOverviewResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface ApplyParams {
  listingAlias: ListingAlias;
}
interface ReassignParams {
  fromListingAlias: ListingAlias;
  toListingAlias: ListingAlias;
}
interface RemoveParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertySpotlightWebApiHandler_apply_Args {
  getParams: ApplyParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_apply_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_apply_Args
>;

/**
 * Apply listing spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_apply = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_apply_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_apply_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_apply(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertySpotlightWebApiHandler_list_Options = UseQueryOptions<
  GetSpotlightedListingsResponseDto,
  unknown,
  GetSpotlightedListingsResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_list_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_list_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_list(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listings with spotlight promotion
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_list = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_list_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_list.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey;

export type RentalManagerUserPropertySpotlightWebApiHandler_overview_Options = UseQueryOptions<
  GetUserPropertySpotlightOverviewResponseDto,
  unknown,
  GetUserPropertySpotlightOverviewResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_overview_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_overview_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_overview(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get spotlight overview for user properties
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_overview = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_overview_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_overview.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey;

export interface RentalManagerUserPropertySpotlightWebApiHandler_reassign_Args {
  getParams: ReassignParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_reassign_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_reassign_Args
>;

/**
 * Reassign listing spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_reassign = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_reassign_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_reassign_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_reassign(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_remove_Args {
  getParams: RemoveParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_remove_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_remove_Args
>;

/**
 * Remove listing spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_remove = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_remove_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_remove_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_remove(args.getParams, httpClient),
  });
};
